/* eslint-disable no-undef */

<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
        <h4> {{$t('Search')}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-5">
        

          <!-- start date -->
        <div class="spacer"></div>
        <label for="startDate" class="vs-input--label">{{$t('From')}}</label>
        <datepicker :format="format" :placeholder="$t('StartDate')" v-model="search.StartDate" input-class="mt-5 w-full" name="startDate" ></datepicker>        
        
        <!-- End date -->
         <div class="spacer"></div>
        <label for="startDate" class="vs-input--label">{{$t('To')}}</label>
        <datepicker :format="format" :placeholder="$t('EndDate')" v-model="search.EndDate" class="mt-5 w-full" name="endDate" ></datepicker>    
                                  <p>{{$t('Course')}}</p>
                                  <v-select
                                          label="Name"
                                         class="mt-5 w-full"                                            
                                            autocomplete
                                          v-model="search.CourseID"
                                          :options="Courses"
                                          :reduce="ID => ID.ID"
                                        />
         <!-- <vs-select class="mt-5 w-full"  name="Course" label="Course" v-model="search.CourseID" > 
           <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in Courses" />
        </vs-select> -->

<p>{{$t('Instructor')}}</p>
                                  <v-select
                                          label="Name"
                                         class="mt-5 w-full"                                            
                                            autocomplete
                                          v-model="search.InstructorID"
                                          :options="Instructors"
                                          :reduce="ID => ID.ID"
                                        />
         <!-- <vs-select class="mt-5 w-full"  name="Instructor" label="Instructor" v-model="search.InstructorID" > 
           <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in Instructors" />
        </vs-select> -->
         

      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="searchAnnualPlan" >{{$t('Search')}}</vs-button>
       <vs-button type="border" class="mr-6" color="danger" @click="resetModel">{{$t('Reset')}}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('Cancel')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from 'vuejs-datepicker';
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleInstructor from "@/store/instructor/moduleInstructor.js";
import vSelect from 'vue-select';
export default {
  
  props: {
    search:{
       type: Object,
      required: true
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
  },
  data() {
    
    return {

       format:"dd-MM-yyyy",
      courses:[],
     
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  

  computed: {
    Courses()
    {
      return this.$store.state.courseList.courses;
    },
     Instructors() {
      debugger;
      return this.$store.state.instructorList.instructors;
    },
    isSidebarActiveLocal: {
    
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSearchSidebar");
         
        }
      }
    },
  },
  created(){
 if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
     if (!moduleInstructor.isRegistered) {
      this.$store.registerModule("instructorList", moduleInstructor);
      moduleInstructor.isRegistered = true;
    }
    this.$store.dispatch("instructorList/fetchDataListItems");
    this.$store.dispatch("courseList/fetchDataListItems");
  },
  methods: {
      resetModel(){
          this.search.CourseID="";
          this.search.InstructorID="";
        //    this.search.AreaOfStudyID=null;
        //this.search={},
      },
    searchAnnualPlan()
    {
      debugger;
      this.$emit("closeSearchSidebar",true);
    }
  },
  components: {
    VuePerfectScrollbar,
      Datepicker,
      vSelect
  }
  
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
